import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class DiscussionsPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.filters = {
      status: 'visible',
      title: '',
      author: '',
      tag_id: '',
      include_descendants: true,
      date_from: '',
      date_to: ''
    };
    if (vnode.attrs.initialAuthor) {
      this.filters.author = String(vnode.attrs.initialAuthor);
    }
    this.items = [];
    this.tags = [];
    this.selected = new Set();
    this.selectedItems = new Map();
    this.expanded = new Set();
    this.allMatching = false;
    this.targetTagId = '';
    this.total = 0;
    this.offset = 0;
    this.limit = 20;
    this.hasMore = false;
    this.loading = false;
    this.error = '';
    this.refreshTimer = null;
    this.search(true);
    this.refreshTimer = window.setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      if (this.loading) return;
      this.search(false);
    }, 30000);
  }
  onremove() {
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
    super.onremove();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  tagLabel(tag) {
    const prefix = tag.depth > 0 ? `${'\u00a0\u00a0'.repeat(tag.depth)}↳ ` : '';
    return `${prefix}${tag.name}`;
  }
  formatDate(value) {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(new Date(value));
    } catch (e) {
      return value;
    }
  }
  forumLabel(item) {
    if (!Array.isArray(item.tags) || !item.tags.length) {
      return '—';
    }
    const child = item.tags.find(tag => tag.parent_id !== null);
    return (child || item.tags[0]).name;
  }
  async search(resetOffset) {
    if (resetOffset === void 0) {
      resetOffset = true;
    }
    if (this.loading) return;
    if (resetOffset) {
      this.offset = 0;
      this.selected.clear();
      this.selectedItems.clear();
      this.allMatching = false;
    }
    this.loading = true;
    this.error = '';
    const qs = new URLSearchParams();
    Object.entries(this.filters).forEach(_ref => {
      let [key, value] = _ref;
      if (value === '') return;
      qs.set(key, typeof value === 'boolean' ? value ? '1' : '0' : value);
    });
    qs.set('offset', String(this.offset));
    qs.set('limit', String(this.limit));
    qs.set('_', String(Date.now()));
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/discussions?' + qs.toString())
      });
      this.items = data.items || [];
      this.tags = data.tags || [];
      this.total = Number(data.total || 0);
      this.hasMore = !!data.has_more;
    } catch (e) {
      this.items = [];
      this.total = 0;
      this.hasMore = false;
      this.error = 'Impossible de charger les discussions.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  toggle(item) {
    const id = item.id;
    this.allMatching = false;
    if (this.selected.has(id)) {
      this.selected.delete(id);
      this.selectedItems.delete(id);
    } else {
      this.selected.add(id);
      this.selectedItems.set(id, {
        id,
        title: item.title || `Discussion #${id}`,
        forum: this.forumLabel(item)
      });
    }
  }
  toggleExpanded(id) {
    if (this.expanded.has(id)) {
      this.expanded.delete(id);
    } else {
      this.expanded.add(id);
    }
  }
  allShownSelected() {
    return this.items.length > 0 && this.items.every(item => this.selected.has(item.id));
  }
  toggleAllShown() {
    this.allMatching = false;
    if (this.allShownSelected()) {
      this.items.forEach(item => {
        this.selected.delete(item.id);
        this.selectedItems.delete(item.id);
      });
    } else {
      this.items.forEach(item => {
        this.selected.add(item.id);
        this.selectedItems.set(item.id, {
          id: item.id,
          title: item.title || `Discussion #${item.id}`,
          forum: this.forumLabel(item)
        });
      });
    }
  }
  selectAllMatching() {
    if (!this.total) return;
    this.allMatching = true;
    this.selected.clear();
    this.selectedItems.clear();
  }
  cancelAllMatching() {
    this.allMatching = false;
  }
  async runRetag() {
    if (this.loading || !this.targetTagId || !this.selected.size && !this.allMatching) {
      return;
    }
    const target = this.tags.find(tag => String(tag.id) === String(this.targetTagId));
    if (!target) return;
    const count = this.allMatching ? this.total : this.selected.size;
    const scope = this.allMatching ? `TOUTES les ${count.toLocaleString('fr-FR')} discussions correspondant aux filtres` : `${count} discussion${count > 1 ? 's' : ''} sélectionnée${count > 1 ? 's' : ''}`;
    if (!confirm(`Confirmer le déplacement de ${scope} vers « ${target.name} » ?`)) {
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/discussions/retag'),
        body: {
          target_tag_id: this.targetTagId,
          ids: Array.from(this.selected),
          all_matching: this.allMatching,
          filters: this.filters
        }
      });
      this.selected.clear();
      this.selectedItems.clear();
      this.allMatching = false;
      alert(`${data.changed || 0} déplacée(s)` + (data.unchanged ? ` · ${data.unchanged} déjà dans ce forum` : '') + (data.denied ? ` · ${data.denied} refusée(s)` : ''));
    } catch (e) {
      this.error = 'Le déplacement n’a pas pu être exécuté.';
    } finally {
      this.loading = false;
    }
    await this.search(false);
  }
  async runMerge() {
    if (this.loading || this.allMatching || this.selected.size !== 2) {
      return;
    }
    const ids = Array.from(this.selected);
    if (!confirm('Fusionner ces 2 discussions ?\n\n' + 'La discussion la plus ancienne sera conservée. ' + 'Les messages de la plus récente seront ajoutés à sa suite.\n\n' + 'La discussion récente sera ensuite supprimée.')) {
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/discussions/merge'),
        body: {
          ids
        }
      });
      this.selected.clear();
      this.selectedItems.clear();
      this.allMatching = false;
      alert(`Fusion terminée : ${data.moved_posts || 0} message(s) déplacé(s).\n` + `Discussion conservée : #${data.target_id}`);
    } catch (e) {
      const detail = e?.response?.errors?.[0]?.detail || e?.response?.error || '';
      this.error = detail ? `Fusion impossible : ${detail}` : 'La fusion n’a pas pu être exécutée.';
    } finally {
      this.loading = false;
    }
    await this.search(false);
  }
  async runAction(action) {
    if (this.loading || !this.selected.size && !this.allMatching) return;
    const label = action === 'hide' ? 'masquer' : action === 'delete' ? 'supprimer définitivement' : 'restaurer';
    const count = this.allMatching ? this.total : this.selected.size;
    const target = this.allMatching ? `TOUTES les ${count.toLocaleString('fr-FR')} discussions correspondant aux filtres` : `${count} discussion${count > 1 ? 's' : ''} sélectionnée${count > 1 ? 's' : ''}`;
    if (action === 'delete' && !confirm(`ATTENTION : suppression définitive de ${count.toLocaleString('fr-FR')} discussion${count > 1 ? 's' : ''}.\n\n` + `Les messages de ces discussions seront également supprimés.\n` + `Cette action est irréversible. Continuer ?`)) {
      return;
    }
    if (!confirm(`Confirmer : ${label} ${target} ?`)) {
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/discussions/actions'),
        body: {
          action,
          ids: Array.from(this.selected),
          all_matching: this.allMatching,
          filters: this.filters
        }
      });
      this.selected.clear();
      this.selectedItems.clear();
      this.allMatching = false;
      alert(`${data.changed || 0} modifiée(s)` + (data.unchanged ? ` · ${data.unchanged} déjà dans cet état` : '') + (data.denied ? ` · ${data.denied} refusée(s)` : ''));
    } catch (e) {
      this.error = 'L’action n’a pas pu être exécutée.';
    } finally {
      this.loading = false;
    }
    await this.search(false);
  }
  previousPage() {
    if (this.offset <= 0 || this.loading) return;
    this.offset = Math.max(0, this.offset - this.limit);
    this.search(false);
  }
  nextPage() {
    if (!this.hasMore || this.loading) return;
    this.offset += this.limit;
    this.search(false);
  }
  goToPage(page) {
    if (this.loading) return;
    const pages = Math.max(1, Math.ceil(this.total / this.limit));
    page = Math.max(1, Math.min(pages, Number(page) || 1));
    const offset = (page - 1) * this.limit;
    if (offset === this.offset) return;
    this.offset = offset;
    this.search(false);
  }
  pagination() {
    var _this = this;
    const pages = Math.max(1, Math.ceil(this.total / this.limit));
    if (pages <= 1) return null;
    const current = Math.floor(this.offset / this.limit) + 1;

    /*
     * Fenêtre glissante de 10 pages.
     */
    const maxStart = Math.max(1, pages - 9);
    const start = Math.max(1, Math.min(current - 4, maxStart));
    const end = Math.min(pages, start + 9);
    const buttons = [];
    const button = function (label, page, disabled, active, title) {
      if (disabled === void 0) {
        disabled = false;
      }
      if (active === void 0) {
        active = false;
      }
      if (title === void 0) {
        title = '';
      }
      return m(active ? 'button.Button.Button--primary' : 'button.Button', {
        type: 'button',
        disabled: disabled || _this.loading,
        title,
        onclick: () => _this.goToPage(page)
      }, label);
    };
    buttons.push(button('Début', 1, current <= 1, false, 'Première page'));
    buttons.push(button('‹', current - 1, current <= 1, false, 'Page précédente'));
    for (let page = start; page <= end; page++) {
      buttons.push(button(String(page), page, false, page === current, 'Page ' + page));
    }
    buttons.push(m('form.ValModerationPageJump', {
      onsubmit: event => {
        event.preventDefault();
        const input = event.currentTarget.querySelector('input');
        const page = Number(input?.value || current);
        this.goToPage(page);
      }
    }, [m('span', 'Page'), m('input.FormControl', {
      type: 'number',
      min: 1,
      max: pages,
      step: 1,
      value: current,
      'aria-label': 'Numéro de page'
    }), m('span', '/ ' + pages), m('button.Button', {
      type: 'submit',
      disabled: this.loading
    }, 'Aller')]));
    buttons.push(button('›', current + 1, current >= pages, false, 'Page suivante'));
    buttons.push(button('Dernière', pages, current >= pages, false, 'Dernière page'));
    return m('.ValModerationPagination', buttons);
  }
  view() {
    const first = this.total ? this.offset + 1 : 0;
    const last = Math.min(this.offset + this.items.length, this.total);
    return m('.ValModerationDiscussions', [m('form.ValModerationFilters', {
      onsubmit: event => {
        event.preventDefault();
        this.search(true);
      }
    }, [m('.ValModerationFilters-grid', [m('label.ValModerationField', [m('span', 'Forum'), m('select.FormControl', {
      value: this.filters.tag_id,
      onchange: event => {
        this.filters.tag_id = event.target.value;
      }
    }, [m('option', {
      value: ''
    }, 'Tous les forums'), ...this.tags.map(tag => m('option', {
      value: String(tag.id)
    }, this.tagLabel(tag)))])]), m('label.ValModerationField.ValModerationField--check', [m('input', {
      type: 'checkbox',
      checked: this.filters.include_descendants,
      onchange: event => {
        this.filters.include_descendants = event.target.checked;
      }
    }), m('span', 'Inclure les sous-forums')]), m('label.ValModerationField', [m('span', 'Auteur'), m('input.FormControl', {
      type: 'search',
      value: this.filters.author,
      placeholder: 'Pseudo ou ID',
      oninput: event => {
        this.filters.author = event.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Titre contient'), m('input.FormControl', {
      type: 'search',
      value: this.filters.title,
      oninput: event => {
        this.filters.title = event.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Du'), m('input.FormControl', {
      type: 'date',
      value: this.filters.date_from,
      onchange: event => {
        this.filters.date_from = event.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Au'), m('input.FormControl', {
      type: 'date',
      value: this.filters.date_to,
      onchange: event => {
        this.filters.date_to = event.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'État'), m('select.FormControl', {
      value: this.filters.status,
      onchange: event => {
        this.filters.status = event.target.value;
      }
    }, [m('option', {
      value: 'visible'
    }, 'Visibles'), m('option', {
      value: 'hidden'
    }, 'Masquées'), m('option', {
      value: 'all'
    }, 'Toutes')])])]), m('.ValModerationFilters-actions', [m('button.Button.Button--primary', {
      type: 'submit',
      disabled: this.loading
    }, this.loading ? 'Recherche…' : 'Rechercher')])]), this.error ? m('.Alert.Alert--error', this.error) : null, m('.ValModerationResultsHeader', [m('strong', `${this.total.toLocaleString('fr-FR')} discussion${this.total > 1 ? 's' : ''}`), m('span', [this.allMatching ? `Toutes les ${this.total.toLocaleString('fr-FR')} correspondantes sélectionnées` : `${this.selected.size.toLocaleString('fr-FR')} sélectionnée${this.selected.size > 1 ? 's' : ''}`, this.total ? ` · Résultats ${first.toLocaleString('fr-FR')} à ${last.toLocaleString('fr-FR')}` : ''])]), m('.ValModerationActions', [m('.ValModerationActionGroup.ValModerationActionGroup--selection', [m('span.ValModerationActionGroup-label', 'Sélection'), m('.ValModerationActionGroup-controls', [!this.allMatching && this.total > this.selected.size ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.selectAllMatching()
    }, `Sélectionner les ${this.total.toLocaleString('fr-FR')} résultats`) : null, this.allMatching ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.cancelAllMatching()
    }, 'Annuler la sélection globale') : null])]), m('.ValModerationActionGroup.ValModerationActionGroup--move', [m('span.ValModerationActionGroup-label', 'Déplacement'), m('.ValModerationActionGroup-controls', [m('select.FormControl', {
      value: this.targetTagId,
      disabled: this.loading,
      onchange: e => {
        this.targetTagId = e.target.value;
      }
    }, [m('option', {
      value: ''
    }, 'Choisir le forum…'), ...this.tags.map(tag => m('option', {
      value: String(tag.id)
    }, this.tagLabel(tag)))]), m('button.Button.Button--primary', {
      type: 'button',
      disabled: !this.targetTagId || !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runRetag()
    }, 'Déplacer')])]), m('.ValModerationActionGroup.ValModerationActionGroup--merge', [m('span.ValModerationActionGroup-label', 'Fusion'), m('.ValModerationActionGroup-controls', [this.selected.size ? m('.ValModerationMergeSelection', Array.from(this.selectedItems.values()).map(item => m('.ValModerationMergeSelection-item', {
      key: item.id
    }, [m('strong', item.title), m('span', ` — ${item.forum}`)]))) : null, m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.allMatching || this.selected.size !== 2 || this.loading,
      title: this.allMatching ? 'La fusion nécessite exactement deux discussions sélectionnées.' : '',
      onclick: () => this.runMerge()
    }, 'Fusionner les 2 discussions')])]), m('.ValModerationActionGroup.ValModerationActionGroup--visibility', [m('span.ValModerationActionGroup-label', 'Visibilité'), m('.ValModerationActionGroup-controls', [m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('hide')
    }, 'Masquer'), m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('restore')
    }, 'Restaurer'), m('button.Button.Button--danger', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('delete')
    }, 'Supprimer définitivement')])])]), m('.ValModerationTableWrap', m('table.ValModerationTable', [m('thead', m('tr', [m('th.ValModerationTable-check', m('input', {
      type: 'checkbox',
      checked: this.allShownSelected(),
      disabled: !this.items.length,
      title: 'Sélectionner les discussions affichées',
      onchange: () => this.toggleAllShown()
    })), m('th', 'Discussion'), m('th', 'Forum'), m('th', 'Auteur'), m('th', 'Date'), m('th.ValModerationTable-number', 'Messages'), m('th', 'État')])), m('tbody', this.loading && !this.items.length ? m('tr', m('td', {
      colspan: 7
    }, 'Chargement…')) : this.items.length ? this.items.flatMap(item => {
      const rows = [m('tr', {
        key: `discussion-${item.id}`
      }, [m('td.ValModerationTable-check', m('input', {
        type: 'checkbox',
        checked: this.selected.has(item.id),
        onchange: () => this.toggle(item)
      })), m('td', [m('a', {
        href: `/d/${item.id}`
      }, item.title || `Discussion #${item.id}`), m('div.ValModerationDiscussionPreview', [m('button.Button.Button--link.ValModerationExpandButton', {
        type: 'button',
        onclick: () => this.toggleExpanded(item.id)
      }, this.expanded.has(item.id) ? 'Replier' : 'Déplier'), item.first_post_excerpt ? m('span', ` ${item.first_post_excerpt}`) : null])]), m('td', this.forumLabel(item)), m('td', item.username || 'Ancien membre'), m('td', this.formatDate(item.created_at)), m('td.ValModerationTable-number', item.comment_count), m('td.ValModerationTable-status', item.hidden_at ? m('span.ValModerationStatus.is-hidden', 'Masquée') : m('span.ValModerationStatus.is-visible', 'Visible'))])];
      if (this.expanded.has(item.id)) {
        rows.push(m('tr', {
          key: `discussion-content-${item.id}`
        }, m('td', {
          colspan: 7
        }, m('.ValModerationMessageContent', {
          oncreate: vnode => {
            vnode.dom.innerHTML = item.first_post_html || '';
          },
          onupdate: vnode => {
            vnode.dom.innerHTML = item.first_post_html || '';
          }
        }))));
      }
      return rows;
    }) : m('tr', m('td', {
      colspan: 7
    }, 'Aucune discussion trouvée.')))])), this.pagination()]);
  }
}